import { ILoggedInUser } from "app/reducers/loginUserSlice";
import { IVenue } from "app/reducers/venueSlice";
import { headers } from "app/_helpers";
import appConstants from "app/_helpers/app.constants";
import axios, { AxiosRequestConfig } from "./axios.service";
import { IBooking } from "app/app.types";

const getAllVenues = async (
  sortBy: string,
  startAt: number = 0,
  getFirst: boolean = false
): Promise<IVenue[]> => {
  console.log(`call to venueService.getAll()`);
  if (!sortBy) sortBy = "-Id";
  let _headers;
  if (window.config.enableOAuth2) {
    _headers = { ...headers.defaultHeaders() };
  } else {
    _headers = {
      ...headers.defaultHeaders(),
      Authorization: `Bearer ${localStorage.getItem("token")}`,
    };
  }
  let reqConfig = {
    headers: _headers,
    params: {
      sort: sortBy,
      start: undefined as number,
      count: undefined as number,
    },
  };

  if (startAt > 0) {
    reqConfig = {
      ...reqConfig,
      params: { ...reqConfig.params, start: startAt },
    };
  }

  if (getFirst) {
    reqConfig = { ...reqConfig, params: { ...reqConfig.params, count: 1 } };
  }

  try {
    const selectedAccountId = localStorage.getItem("selectedAccountId");
    const url = `${appConstants.backendApiUrl}/accounts/${selectedAccountId}/venues`;
    const result = await axios.get<IVenue[]>(url, reqConfig);
    return result.data;
  } catch (error) {
    console.warn(`call to venueService.getAllVenues() failed. ${error}`);
  }
  return null;
};

const venueService = {
  getAll: getAllVenues,
  getDefaultVenue: async (): Promise<IVenue> => {
    console.log(`call to venueService.getDefaultVenue()`);
    try {
      const result = await getAllVenues("-Id", undefined, true);
      if (result && result.length > 0) {
        return result[0];
      }
      return null;
    } catch (error) {
      console.warn(`call to venueService.getDefaultVenue() failed. ${error}`);
      return null;
    }
  },
  getById: async (venueId: number): Promise<IVenue> => {
    console.log(`call to venueService.getById(${venueId})`);
    try {
      const reqConfig = MakeRequestConfiguration({});
      const selectedAccountId = localStorage.getItem("selectedAccountId");
      const url = `${appConstants.backendApiUrl}/accounts/${selectedAccountId}/venues/${venueId}`;
      const result = await axios.get<any>(url, reqConfig);
      if (result?.data) {
        return {
          id: result.data.id,
          name: result.data.venueName,
          isPosActive: result.data.isPOSActive,
          timeZoneId: result.data.ianaTimeZoneId,
        } as IVenue;
      }
      return result.data;
    } catch (error) {
      console.warn(`call to venueService.getById(${venueId}) failed. ${error}`);
    }
    return null;
  },
  getBookingsForToday: async (
    loggedInUser: ILoggedInUser,
    venueId: number
  ): Promise<IBooking[]> => {
    try {
      const reqConfig = MakeRequestConfiguration(null);
      const result = await axios.get<IBooking[]>(
        `${appConstants.backendApiUrl}/restaurants/venues/${venueId}/reports/FindBookingsForToday`,
        reqConfig
      );
      return result.data;
    } catch (error) {
      console.warn(
        `call to venueService.getBookingsForToday(${venueId}) failed. ${error}`
      );
    }
    return null;
  },
};

/**
 * Make authorization header and request parameters
 */
function MakeRequestConfiguration(reqParameters: any): AxiosRequestConfig {
  let _headers: any;
  if (window.config.enableOAuth2) {
    _headers = { ...headers.defaultHeaders() };
  } else {
    _headers = {
      ...headers.defaultHeaders(),
      Authorization: `Bearer ${localStorage.getItem("token")}`,
    };
  }
  const reqConfig: AxiosRequestConfig = {
    headers: _headers,
    params: reqParameters,
  };

  return reqConfig;
}

export default venueService;
